import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import RichTextEditor from 'v2/form/RichTextEditor/RichTextEditor';
import TextArea from 'v2/form/TextArea/TextArea';
import { SignUpFlowFormData } from './SignUpFlow';

interface StepFourProps {
  register: UseFormRegister<SignUpFlowFormData>;
  errors: FieldErrors<SignUpFlowFormData>;
  setValue: UseFormSetValue<SignUpFlowFormData>;
  formValues: SignUpFlowFormData;
}

const StepFour = ({
  register,
  errors,
  setValue,
  formValues,
}: StepFourProps) => {
  return (
    <div>
      <FormGroup className="mt-4">
        <FormLabel
          label="Organization Detailed Description"
          required={true}
          error={errors?.long_description?.message}
        />
        <RichTextEditor
          data-cy="signup:organization-description"
          value={formValues.long_description}
          readOnly={false}
          onChange={(data) =>
            setValue('long_description', data, {
              shouldValidate: true,
              shouldDirty: true,
            })
          }
        />
      </FormGroup>

      {formValues.user_type === 'data_buyer' ? (
        <FormGroup className="mt-4">
          <TextArea
            label="Anonymous Description (used when you hide your identity when 
              submitting a data request to our network of external data providers)"
            register={register('vague_description', { required: true })}
            error={errors?.vague_description?.message}
            autoComplete="off"
            required={true}
            cols={10}
            data-cy="signup:anonymous-description"
          />
        </FormGroup>
      ) : null}
    </div>
  );
};

export default StepFour;
